import React from "react";
import styled from "styled-components";
import { isiOSDevice } from "../../../constants/deviceType";
// MAX_MESSAGE_LENGTH import removed - now passed as prop

const Input = styled.input`
  margin: 0;
  flex-grow: 1;
  width: 100%;
  filter: none;
  border-radius: 1rem;
  font-size: var(--fs-body);
  background-color: var(--clr-tert);
  color: var(--clr-sec);
  padding: 0.5rem 4rem 0.5rem 0.75em;
  border: 0px;
  outline: none;
  line-height: 1;
`;

const InputBox = React.forwardRef((props, ref) => {
  return (
    <Input
      // Do not autofocus on iOS devices due to weird input box behavior
      autoFocus={isiOSDevice() ? false : true}
      autoComplete="off"
      autoCorrect="on"
      autoCapitalize="sentences"
      spellCheck="true"
      inputMode="text"
      enterKeyHint="send"
      ref={ref}
      placeholder="What's on your mind?"
      maxLength={props.messageLimit}
      tabIndex="-1"
      disabled={props.disabled}
      value={props.value}
      onChange={(event) => {
        props.onChange(event.target.value);
      }}
      onFocus={props.onFocus}
      onBlur={props.onBlur}
    />
  );
});

export default InputBox;
